import SettingsDrawer from '@Common/components/drawer/SettingsDrawer';
import { RootState } from '@Common/models/redux/store';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGcSettingValue } from 'src/grammar-checker/actions/controlActions';
import commonTrack from '@Common/handlers/track';
import { GcSettingNames } from '../models/GrammarCheck';

const GC_SETTINGS = {
  gcFluencyModeEnabled:
    QuillLocalStorage.getInstance().get('gcFluencyModeEnabled', 'true') === 'true',
};

const GcSettingsDrawer = () => {
  const [check, setCheck] = useState(false);

  const dispatch = useDispatch();
  const isGrammarCheckRunning = useSelector(
    (rootState: RootState) => rootState.grmr.controls.isGrammarCheckRunning
  );

  const handleChange = (event: any, prop: any) => {
    const newValue = event.target.checked;

    switch (prop) {
      case 'gcFluencyModeEnabled':
        dispatch(setGcSettingValue(GcSettingNames.GC_FLUENCY_MODE, event.target.checked));
        break;
      default:
        break;
    }
    QuillLocalStorage.getInstance().set(prop, newValue);
    setCheck(!check);
    commonTrack.settingChanged({ [prop]: newValue });
  };

  const checkboxesToShow = [
    {
      'Grammar Checker': [
        {
          label: 'Sentence Suggestions',
          prop: 'gcFluencyModeEnabled',
          tooltip: '',
          alwaysUnchecked: undefined,
          disabled: isGrammarCheckRunning,
        },
      ],
    },
  ];

  return (
    <SettingsDrawer
      grammarSettings={GC_SETTINGS}
      checkboxesToShow={checkboxesToShow}
      handleChange={handleChange}
    />
  );
};

export default GcSettingsDrawer;
